var Gate5 = Gate5 || {};

Gate5.Navbar = function () {

  let lastScrollTop = 50;
  const _nav = '#Navbar';

  var _init = function () {
    $(window).scroll(function() {
        let st = $(this).scrollTop();
        // Scroll down and past the navbar
        if (st > lastScrollTop) {
            // Adjust the value based on the height of your navbar
            $(_nav).css("top", "-130px");
        } else {
            if(st == 0 && $(window).width() >= 768) {
                $(_nav).css("top", "36px");
            } else {
                $(_nav).css("top", "0");
            }
        }
        lastScrollTop = st;
    });
  }

    /** PUBLIC API **/
    return {
        init: function () { return _init(); }
    };

}();

jQuery(document).ready(function () {
    Gate5.Navbar.init();
});
